import { render, staticRenderFns } from "./CustomerCCDR.vue?vue&type=template&id=47b3da01&scoped=true&"
import script from "./CustomerCCDR.vue?vue&type=script&lang=ts&"
export * from "./CustomerCCDR.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b3da01",
  null
  
)

export default component.exports